import { Result, RoundType } from "../interfaces/ICompetitions";

/**
 * Sortuje wyniki eliminacji
 * Kolejność: awansowani (promotion=true) na górze, potem po ID prezentacji
 */
const sortEliminationResults = (results: Result[]): Result[] => {
  return [...results].sort((a, b) => {
    // Najpierw awansowani
    if (a.promotion && !b.promotion) return -1;
    if (!a.promotion && b.promotion) return 1;

    // Potem po ID prezentacji
    const idA = a.presentation.id;
    const idB = b.presentation.id;

    // Sprawdź czy ID są numeryczne
    const numA = Number(idA);
    const numB = Number(idB);

    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }

    // Jeśli nie numeryczne, sortuj alfabetycznie
    return idA.localeCompare(idB, "pl");
  });
};

/**
 * Sortuje wyniki finału
 * Kolejność: po miejscu (place), od najlepszego
 */
const sortFinalResults = (results: Result[]): Result[] => {
  return [...results].sort((a, b) => {
    const placeA = a.place ?? Number.MAX_SAFE_INTEGER;
    const placeB = b.place ?? Number.MAX_SAFE_INTEGER;
    return placeA - placeB;
  });
};

/**
 * Sortuje wyniki rundy w zależności od typu rundy
 */
export const sortRoundResults = (results: Result[], roundType: RoundType): Result[] => {
  if (roundType === RoundType.FINAL) {
    return sortFinalResults(results);
  }
  return sortEliminationResults(results);
};

